import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useAdminAuth() {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      console.log('[useAdminAuth] Checking admin status...');
      
      // First check if user is authenticated
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      
      console.log('[useAdminAuth] Auth check:', { 
        hasUser: !!user, 
        userId: user?.id,
        userEmail: user?.email,
        authError: authError?.message 
      });
      
      if (authError || !user) {
        console.log('[useAdminAuth] Not authenticated, setting admin to false');
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      
      // Check is_admin field
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('is_admin')
        .eq('id', user.id)
        .single();
      
      console.log('[useAdminAuth] Profile query result:', { 
        profile, 
        error: profileError?.message,
        errorCode: profileError?.code
      });
      
      const adminStatus = profile?.is_admin === true;
      console.log('[useAdminAuth] Admin status result:', adminStatus);
      setIsAdmin(adminStatus);
    } catch (error) {
      console.error('[useAdminAuth] Failed to check admin status:', error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  return { isAdmin, loading, checkAdminStatus };
}
